// src/services/coupon.service.js
import axios from "axios";
import { auth } from "../config/firebase";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5172/api";

const getAuthHeader = async () => {
  const user = auth.currentUser;
  if (!user) return {};
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
};

export const couponService = {
  validateCoupon: async (code, cartTotal) => {
    try {
      const headers = await getAuthHeader(); // ✅ Get the Firebase token securely

      const response = await axios.post(
        `${API_URL}/coupons/validate`,
        { code, cartTotal },
        { headers }, // ✅ Pass the correct headers
      );

      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message);
      }
      throw new Error("Failed to validate coupon");
    }
  },
};
